<template>
      <div class="modal2" v-show="value">
      
          <b-form-group label="Set up item">
        <div class="container" style="position:relative">
          
		  	<span class="rightmenu dlgbutton" style="position: absolute; right: 1rem;"> 
	        	<b-button v-on:click="closeLabel" variant="danger">
	        		<b-icon  icon="x"></b-icon>
	        		Cancel
	        	</b-button>	        	
	        </span>
	        <h1>Set up item</h1>	        
	        
	        <div v-if="rect !== null" ><textarea rows="1" cols="40"v-model="editedText" placeholder="Item name"></textarea></div>
	    	<br/>
	    	
	    	<div v-if="rect !== null" ><textarea rows="3" cols="40"v-model="editedDescription" placeholder="Describe your item"></textarea></div>
	    	<br/>
		
		    
		    
		    <b-form-group label="Size">
		      <b-form-radio-group
		        id="btn-radios-size"
		        v-model="labelSize"	        
		        buttons
		        button-variant="outline-primary"
		        size="lg"
		        name="radio-btn-outline"
		      >	      
		      	<b-form-radio value="100">Small</b-form-radio>
		      	<b-form-radio value="150">Medium</b-form-radio>
		      	<b-form-radio value="200">Large</b-form-radio>
		      	<b-form-radio value="300">Huge</b-form-radio>
		      </b-form-radio-group>
		    </b-form-group>
		    
			<b-form-group label="Location">
		      <b-form-radio-group
		        id="btn-radios-location"
		        v-model="location"	        
		        buttons
		        button-variant="outline-primary"
		        size="lg"
		        name="radio-btn-outline"
		      >	      
		      	<b-form-radio value="board">On the board</b-form-radio>
		      	<b-form-radio value="player">In my player area</b-form-radio>
		      </b-form-radio-group>
		    </b-form-group>
			
			

	        <div class="leftmenu dlgbutton"	> 
	        	<b-button v-on:click="deleteLabel" variant="warning">
	        		<b-icon  icon="exclamation-triangle-fill"></b-icon>
	        	Delete
	        	</b-button>	        	
	        </div>

	        <span class="rightmenu dlgbutton"	>
	        	<b-button v-on:click="savecloseLabel" variant="success">
	        		<b-icon  icon="check2"></b-icon>
	        		OK
	        	</b-button>	        	
	        </span>
	      	<br/>
	      	<br/>
	      	<br/>
        </div>
        </b-form-group>
      
      
      
      </div>
     </div>  
    </template>

    <script>
        export default {
            name: 'EditItem',
            props: {
                value: {
                    required: true
                },
                rect: Object,                             
            },
            data:  function () {
    			return {
    			editedText:"",
    			editedDescription:"",
    			labelSize:200,
    			location:"player"
    			}
    		},
            watch: { 
		      	value: function() { // reload data when the dialog opens
		          if (this.rect){
		            this.editedText = this.rect.label;
		            this.editedDescription = this.rect.description;	            
		            this.labelSize = this.rect.width;
		            this.location = this.rect.location;
		          }
		        }
		      },
            methods: {
                closeLabel() {                	
                	// TODO, not sure why this closes the dialog
                	this.$emit("input", !this.value);
                },
                savecloseLabel() {
                	
                	if (this.rect){
                		this.rect.label = this.editedText;                		
                		this.rect.width = parseInt(this.labelSize);
                		this.rect.height = parseInt(this.labelSize);
                		this.rect.description=this.editedDescription;	
                		this.rect.location = this.location;
                	}
                	// TODO, not sure why this closes the dialog
                	this.$emit("input", !this.value);
                    this.$emit("edited", this.rect);
                },
                deleteLabel() {
                	// TODO, not sure why this closes the dialog
                	this.$emit("input", !this.value);
                    this.$emit("deleted", this.rect);
                }             
            }
        };
    </script>


    <style lang="css" scoped>
    	h1 {
    		padding:20px;
    	}
    	
    .menuitem img{height: 64px;  margin-top:2px;}
    .menubar {height:72px;background:#fff; border:1px solid lightgrey; background-color:#eee;}
	
    
        .modal2 {
          background-color: rgba(0, 0, 0, 0.7);
          position: absolute;
  		  top: 0;
  		  right: 0;   
  		  left: 0;
  		  bottom: 0;         
      }
      
      .container{
      	background-color: #fff;
      	margin:50px;
      }
      
      textarea {font:Verdana;
      	font-size:30px;
      	}
      	
      .radiobuttons {
      margin:20px;      
      }
      	
      .dlgbutton {
      	margin:20px;
      }
    </style>